/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meetings_Exception_Series_HintInputs */



/**
* | output |
* | --- |
* | "Applies to this meeting and all its repetitions." |
*
* @param {Meetings_Exception_Series_HintInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meetings_exception_series_hint = /** @type {((inputs?: Meetings_Exception_Series_HintInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meetings_Exception_Series_HintInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Geldt voor dit gesprek en al zijn herhalingen.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("S'applique à cette conversation et à toutes ses répétitions.")
	return /** @type {LocalizedString} */ ("Applies to this meeting and all its repetitions.")
});